import { setLocale } from "yup";
import i18next from "i18next";

// Default yup messages for rules without a custom message. They are functions, so they are
// translated when validation runs and follow the current language. yup reads its locale when a
// rule is created, so this module has to be imported before any module building schemas at
// import time - keep it as the first import in index.tsx.
const t = (key: string, params?: object) =>
  i18next.t(`nav.validation.${key}`, { ns: "admin", ...params }) as string;

setLocale({
  mixed: {
    default: () => t("invalid"),
    required: () => t("required"),
    oneOf: () => t("oneOf"),
    notType: () => t("invalidType"),
  },
  string: {
    length: ({ length }) => t("exactLength", { length }),
    min: ({ min }) => t("minLength", { min }),
    max: ({ max }) => t("maxLength", { max }),
    matches: () => t("invalidFormat"),
    email: () => t("email"),
  },
  number: {
    min: ({ min }) => t("minValue", { min }),
    max: ({ max }) => t("maxValue", { max }),
    integer: () => t("integer"),
  },
});
